import { Link } from 'gatsby';
import React from 'react';
import { NavBarTypes } from './navBarTypes';
import { desktopscreensize } from '../../../../utilities/constants';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { HEADER_ICON_SIZES } from '../Header/constants';
import { weakKey } from '../../../../utilities/weakKey';

export const NavBarButtonLinks = ({
  handleNavBarStateButton,
  width,
  buttonConfig,
  index,
}: NavBarTypes.TGenericButtonGroupType) => {
  const getNavBarBurgerButtonClassName = (index: number) => {
    return `navBarBurgerButton${index + 1} ${
      index === 1
        ? 'cp-primary-button-highlighted has-text-white'
        : 'cp-outline-button-highlighted has-text-highlight'
    }`;
  };
  const getNavBarButtonsClassName = (index: number) => {
    if (index === 0) {
      return width < desktopscreensize
        ? `navBarBurgerButton${index + 1} has-text-white`
        : `navBarButton${index + 1}`;
    } else {
      return width < desktopscreensize
        ? getNavBarBurgerButtonClassName(index)
        : `navBarButton${index + 1} has-text-white`;
    }
  };
  return (
    <>
      <div>
        <Link
          to={buttonConfig.url}
          onClick={(e: any) => handleNavBarStateButton(e)}
          className={`subtitle1 ${getNavBarButtonsClassName(index)}`}
          key={weakKey(buttonConfig)}
          state={{
            from: buttonConfig.label.toLowerCase().replace(/\s/g, ''),
            dataFrom: 'ctaButton',
          }}
        >
          {buttonConfig.label}&nbsp;
          {buttonConfig.icon && width < desktopscreensize ? (
            <FontAwesomeIcon
              iconClassName={buttonConfig.icon.name}
              iconContextProps={{
                style: {
                  fontSize:
                    buttonConfig.icon.size ?? HEADER_ICON_SIZES.iconSize,
                  verticalAlign: 'text-top',
                },
              }}
            />
          ) : (
            ''
          )}
        </Link>
      </div>
    </>
  );
};
